<script>
    import {labels} from "../timelines/main-timeline";
    import {onMount} from "svelte";
    import gsap from "gsap";
    import {mainTimeline} from "../timelines/main-timeline";
    import BlinkingGnosis from "./Elements/BlinkingGnosis.svelte";
    import ControlledAudio from "../uiElements/ControlledAudio.svelte";

    export let audioMuted = false;

    let gnosis;
    let sfx;
    const gnosisTimeline = gsap.timeline();
    const outAnimation = gsap.timeline();

    const gnosisFinalInTimeline = gsap.timeline();
    const customerJourneyInTimeline = gsap.timeline();

    const {gnosisStart, gnosisEnd, gnosisFinalStart, customerJourneyStart} = labels;

    const onComplete = () => {
        playSfx();
    };

    const gnosisInTheCorner = {
        opacity: 0,
    };

    const reset = {
        x: 0,
        y: 100,
        scale: 1,
        opacity: 1,
    };

    const finalPosition = {
        ...reset,
        scale: 0.6,
        transformOrigin: '0% 0%',
        x: 80,
        y: 260,
    };

    function playSfx() {
        sfx && sfx.play();
    }

    onMount(() => {
        gnosisTimeline
            .set(gnosis, {
                opacity: 1,
                duration: 0.1,
                ...reset,
                onComplete,
            })
            .set(gnosis, {
                opacity: 0
            }, '>+=0.05')
            .set(gnosis, {
                opacity: 1
            }, '>+=0.05')
            .set(gnosis, {
                opacity: 0
            }, '>+=0.05')
            .set(gnosis, {
                opacity: 1
            }, '>+=0.05')
        ;

        outAnimation
            .set(gnosis, {...gnosisInTheCorner, onComplete})
            .set(gnosis, reset, 0.1)
            .set(gnosis, gnosisInTheCorner, 0.2)
            .set(gnosis, reset, 0.3)
            .set(gnosis, gnosisInTheCorner, 0.4)


        customerJourneyInTimeline
            .set(gnosis, {...finalPosition, onComplete})
            .set(gnosis, gnosisInTheCorner, 0.1)
            .set(gnosis, finalPosition, 0.2)
            .set(gnosis, gnosisInTheCorner, 0.3)
            .set(gnosis, finalPosition, 0.4)

        gnosisFinalInTimeline
            .to(gnosis, {...reset, duration: 1}, 0.4)

        mainTimeline.add(gnosisTimeline, gnosisStart + '+=0.5');
        mainTimeline.add(outAnimation, gnosisEnd + '+=0.1');
        mainTimeline.add(customerJourneyInTimeline, customerJourneyStart);
        mainTimeline.add(gnosisFinalInTimeline, gnosisFinalStart);
    });

</script>

<g class=gnosis bind:this={gnosis}>
    <BlinkingGnosis />
</g>

<foreignObject width="0" height="0">
    <body>
        <ControlledAudio bind:this={sfx} src="audio/gnosis.mp3" audioMuted={audioMuted} />
    </body>
</foreignObject>

<style>
    .gnosis {
        opacity: 0;
    }
</style>